import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";
import Configs from "../../images/configs.png";
import UpdateConfigs from "../../images/updateConfigs.png";

const Config = () => {
  const ConfigDocs = {
    title: "Configuration Management",
    description: "Learn how to manage and update critical app configurations to ensure smooth app functionality.",
    sections: [
      {
        title: "Overview",
        content: "The Configurations section allows you to manage essential settings that control various features of the app.",
        image: Configs,
        imageAlt: "Update Configurations",
        imageCaption: "Figure 1: Overview of the App Configuration Dashboard",
      },
  
      {
        title: "Update Configurations",
        content: "This section provides options to update key configurations within the app. Click 'Update' to apply changes to each setting.",
        image: UpdateConfigs,
        imageAlt: "Update Configurations",
        imageCaption: "Figure 2: Interface for Updating Configurations",
        subsections: [
          {
            title: "Steps to Update Configuration Settings",
            content: "Follow these steps to update specific app configurations. Each setting helps control app features and enhance the user experience.",
            steps: [
              "Delivery Limit for Payment on Delivery: Adjusts the maximum order amount allowed for customers opting to pay on delivery. Use this to set a cap on payment amounts for deliveries.",
              "Payment Cap: Specify the maximum payment amount allowed per transaction. This cap ensures secure, manageable transaction limits within the app.",
              "Payment Threshold: Set a minimum order amount required to trigger specific app features, such as free shipping or special discounts.",
              "Payable Security Deposit: Defines the security deposit amount required for certain orders. This setting can help mitigate potential risks for high-value orders.",
              "WhatsApp Community Link: Add or update the WhatsApp group link to allow customers to join the community. This feature is useful for engagement and support.",
              "Become a Supplier Link: Provide or update the link to the supplier application form. This feature enables new suppliers to join by completing the form linked here.",
            ],
          },
        ],
      },
    ],
  };  
  return <FeatureDocumentation {...ConfigDocs} />;
};

export default Config;
